import type { IClientColors } from '@/clients/clientRegistry';

function hexToRgbChannels(hex: string): string {
    const result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
    if (!result) {
        return '0 0 0';
    }
    return `${parseInt(result[1], 16)} ${parseInt(result[2], 16)} ${parseInt(result[3], 16)}`;
}

function applyClientTheme(colors: IClientColors): void {
    const root = document.documentElement;
    root.style.setProperty('--color-primary', hexToRgbChannels(colors.primary));
    root.style.setProperty('--color-bg-primary', hexToRgbChannels(colors.bgPrimary));
    root.style.setProperty('--color-bg-secondary', hexToRgbChannels(colors.bgSecondary));
    root.style.setProperty('--color-border-primary', hexToRgbChannels(colors.borderPrimary));
    root.style.setProperty('--color-border-secondary', hexToRgbChannels(colors.borderSecondary));
    root.style.setProperty('--color-hover-primary', hexToRgbChannels(colors.hoverPrimary));
    root.style.setProperty('--color-hover-secondary', hexToRgbChannels(colors.hoverSecondary));
    root.style.setProperty('--color-hover-tertiary', hexToRgbChannels(colors.hoverTertiary));
    root.style.setProperty('--color-hover-quaternary', hexToRgbChannels(colors.hoverQuaternary));
    root.style.setProperty('--color-secondary', hexToRgbChannels(colors.secondary));
    root.style.setProperty('--color-surface-glass', hexToRgbChannels(colors.surfaceGlass));
    root.style.setProperty('--color-surface-card', hexToRgbChannels(colors.surfaceCard));
    root.style.setProperty('--color-surface-default', hexToRgbChannels(colors.surfaceDefault));
    root.style.setProperty('--color-text', hexToRgbChannels(colors.text));
}

export { applyClientTheme };
